import {type HTMLAttributes} from 'react';

import styles from './styles.module.css';

type Props = {
    size?: number;
    color?: string;
} & HTMLAttributes<HTMLSpanElement>

export const Spinner = ({
    size = 24,
    color = 'rgb(var(--time-webkit-color-main-rgb, 22, 109, 224)',
    ...props
}: Props) => {
    return (
        <span
            {...props}
            className={styles.base}
            style={{width: `${size}px`, height: `${size}px`}}
            data-testid='spinner'
            role='progressbar'
        >
            <span className={styles.animatedWrapper}>
                <svg viewBox='0 0 100 100'>
                    <circle
                        fill='none'
                        className={styles.circle}
                        stroke={color}
                        cx='50'
                        cy='50'
                        r='44'
                    />
                </svg>
            </span>
        </span>
    );
};
